import {
  athenaCoverageResolutionPreviewSchema,
  athenaCoverageResolutionResponseSchema,
  resolveAthenaCoverageSchema,
  type ResolveAthenaCoverage,
} from "@/src/models/athena-coverage-resolution";
import { fetchJSON } from "@/src/requests/utils/fetch-json";

export async function getAthenaCoverageResolution(taskId: string) {
  return athenaCoverageResolutionPreviewSchema.parse(await fetchJSON(`/api/tasks/${taskId}/resolve-insurance`));
}

export async function submitAthenaCoverageResolution(taskId: string, input: ResolveAthenaCoverage) {
  return athenaCoverageResolutionResponseSchema.parse(
    await fetchJSON(`/api/tasks/${taskId}/resolve-insurance`, {
      method: "POST",
      body: JSON.stringify(resolveAthenaCoverageSchema.parse(input)),
    })
  );
}
